import { IRoadIdentifierIconProps } from "../ManeuverLabel";

export function FylkesveiIcon(props: IRoadIdentifierIconProps) {
    const roadIdentifier = props.roadIdentifier;
    return (
        <span className={"fylkesvei-icon"}>
                <span className={"fylkesvei-icon-inner"}>
                    {roadIdentifier}
                </span>
            </span>
    );
}